import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 63B2417B-4DCD-4DE3-A899-10851795B46F
 * name mouse-move-up
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mouse-move-up.svg
 * tags
 */
export const MouseMoveUpIcon = createSvgIcon(<><path d="M7 9H2C2 6.04 4.17 3.57 7 3.09V9M18 17H20V11H23L19 7L15 11H18V17M9 3.09V9H14C14 6.04 11.83 3.57 9 3.09M2 15C2 18.3 4.7 21 8 21S14 18.3 14 15V11H2V15Z" /></>, 'MouseMoveUpIcon');
export default MouseMoveUpIcon